import React from 'react';
import Logo from '../../assets/svg/logo.svg';
import {Link} from 'react-router-dom';

const NavbarIcon = () => {
  return (
      <Link to="/" className="flex items-center">
        <img
            src={Logo}
            alt="Logo"
            className="w-[64px] relative"
        />
      </Link>
  );
};

export default NavbarIcon;